import { PayloadAction, createSlice } from '@reduxjs/toolkit';
export const ROUTE_KEY = 'app::route';
type pageType = {
    goto: boolean;
};
type otherType = {
    toPage: string;
};
export type RouteState = pageType & otherType;
const initialRouteState = {
    goto: false,
    toPage: '',
} as RouteState;
const goto = {
    reducer(state: RouteState, action: PayloadAction<otherType>) {
        state.goto = true;
        state.toPage = action.payload.toPage;
    },
    prepare(payload: string) {
        return {
            payload: {
                toPage: payload,
            },
        };
    },
};
const close = (state: RouteState) => {
    state.goto = false;
};
const routeSlice = createSlice({
    name: ROUTE_KEY,
    initialState: initialRouteState,
    reducers: {
        goto,
        close,
    },
});
export const routeSliceReducer = routeSlice.reducer;
export const routeSliceActions = routeSlice.actions;
